const cashPayment = (state = false, action) => {
    switch(action.type) {
        case 'cashPayment':
            return action.payload;
        default:
            return state;
    }
}

export default cashPayment;